import { compressImage } from "./compress_image";

export const compressImages = async (files) => {
    const results = [];
    
    for (const file of files) {
      try {
        const compressed = await compressImage(file);
        results.push({
          file: compressed,
          originalSize: file.size,
          compressedSize: compressed.size
        });
      } catch (err) {
        console.warn(`Skip file ${file.name}:`, err.message);
      }
    }
  
    return results;
  };
  